import React, { Component } from "react";

import _ from 'lodash';

import { Link } from "react-router";

export default class MenuItem extends Component {
    render() {
        const styleColor = (this.props.color ? { color: this.props.color} : {})
        const location = window.location.hash.split("#")[1];
        return (
            <li className={location === this.props.path ? "active" : ""} onClick={this.props.closeMenu}>
                <Link to={this.props.path}>
                    {!_.isUndefined(this.props.icon) ? (
                        <i className={`icon-${this.props.icon}`} style={{ margin: 0, marginLeft: -5, fontSize: 25, ...styleColor }} />
                    ) : null}
                    <span style={{verticalAlign: 'super', fontSize: '1.6rem', ...styleColor}}>&nbsp;&nbsp;{this.props.label}</span>
                </Link>
            </li>
        );
    }
}